export default {
	UPDATE_TENANT_ID(state, tenantId) {
		state.tenantId = tenantId
	},

	SET_TENANT_ID(state, payload) {
		state.tenantId = payload
	},

	SET_SETTINGS(state, payload) {
		state.settings = payload
	},

	SET_USERNAME(state, payload) {
		state.username = payload
	},

	SET_EMAIL(state, payload) {
		state.email = payload
	},

	SET_PERMISSIONS(state, payload) {
		state.permissions = payload
	},

	SET_IS_READY(state, payload) {
		state.isReady = payload
	},

	SET_NONEXISTENT_SETTINGS(state, payload) {
		state.nonexistentSettings = payload
	},

	SET_MENU(state, payload) {
		state.isMenuVisible = payload
	},

	ADD_MESSAGE(state, payload) {
		state.messages = [payload]
	},

	REMOVE_MESSAGE(state, payload) {
		if (payload) {
			state.messages.splice(state.messages.indexOf(payload), 1)
		} else state.messages.splice(0, 1)
	},

	ADD_LOADING(state) {
		state.loading.push(1)
	},

	REMOVE_LOADING(state) {
		state.loading.splice(0, 1)
	}
}
